import React from 'react';
import { AndroidWatchesFormState } from './androidWatchesFormState/AndroidWatchesFormState';
import { InputFields } from './components/InputFields';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import classNames from 'classnames';
import style from './AndroidWatchesForm.module.scss';

interface IAndroidWatchesForm {
	isVisible: boolean;
}

export const AndroidWatchesForm: React.FC<IAndroidWatchesForm> = React.memo(({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="AndroidWatchesForm">
			<AndroidWatchesFormState>
				<InputFields />
				<ModalWindows />
			</AndroidWatchesFormState>
		</div>
	);
});
